import { useTranslation } from 'react-i18next'
import { AuroraCirculationPumpMode } from '../enums'
import { MouseEvent } from 'react'
import {
  CircularProgress,
  FormControlLabel,
  FormGroup,
  ToggleButton,
  ToggleButtonGroup,
  useTheme
} from '@mui/material'

export interface AuroraCirculationPumpModeControlProps {
  value: AuroraCirculationPumpMode
  loading?: boolean
  onSubmit: (mode: AuroraCirculationPumpMode) => void
}

export default function AuroraCirculationPumpModeControl({
  value,
  loading = false,
  onSubmit
}: AuroraCirculationPumpModeControlProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('aurora')

  /**
   * The theme.
   */
  const theme = useTheme()

  /**
   * Handle the change event.
   */
  function handleChange(_: MouseEvent<HTMLElement>, newValue: AuroraCirculationPumpMode) {
    onSubmit?.(newValue)
  }

  return (
    <FormGroup
      sx={{
        p: 4,
        pb: 6,
        borderRadius: 2,
        background: theme.palette.background.default
        // minHeight: 150
      }}
    >
      <FormControlLabel
        value="bottom"
        control={
          <>
            {loading ? (
              <CircularProgress size={24} sx={{ m: 4 }} />
            ) : (
              <ToggleButtonGroup
                color="primary"
                value={value}
                sx={{ mt: 2 }}
                exclusive
                onChange={handleChange}
              >
                <ToggleButton value={AuroraCirculationPumpMode.AUTO}>{t('auto')}</ToggleButton>
                <ToggleButton value={AuroraCirculationPumpMode.MAX}>{t('max')}</ToggleButton>
                <ToggleButton value={AuroraCirculationPumpMode.MIN}>{t('min')}</ToggleButton>
              </ToggleButtonGroup>
            )}
          </>
        }
        label={t('circulationPumpMode')}
        labelPlacement="top"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          m: 0,
          color: 'text.secondary'
        }}
      />
    </FormGroup>
  )
}
